function Shopyourway() {
    return (
      <div>
        <div className="grid">
          <div>
            <img
              src="https://n.nordstrommedia.com/id/4a106178-c496-41a7-aab4-8ddb8b521c51.jpeg?h=188&w=367"
              alt=""
            />
            <h4>We're in Your Neighborhood!</h4>
            <p>Shop with extra safety measures.</p>
            <a href="" style={{ color: "skyblue" }}>
              Find Your Rack
            </a>
          </div>
          <div>
            <img
              src="https://n.nordstrommedia.com/id/2d67e782-2cd8-44b8-abf7-a4c355c32ea5.jpeg?h=188&w=367"
              alt=""
            />
            <h4>Free Returns in Stores</h4>
            <p>
              You can return online purchases to any Nordstrom Rack or Nordstrom
              store.
            </p>
            <a href="" style={{ color: "skyblue" }}>
              Learn More
            </a>
          </div>
          <div>
            {" "}
            <img
              src="https://n.nordstrommedia.com/id/272ef982-d35d-4e00-b78b-5a2eae13273a.jpeg?h=188&w=365"
              alt=""
            />
            <h4>Ship to Store</h4>
            <p>
              Pick up select online and in app orders at a Nordstrom Rack or
              Nordstrom store!{" "}
            </p>
            <a href="" style={{ color: "skyblue" }}>
              Shipping & Pickup Info
            </a>
          </div>
          <div>
            <img
              src="https://n.nordstrommedia.com/id/78a0f7f8-2873-41fe-92f2-f0515371cb9e.jpeg?h=188&w=367"
              alt=""
            />
            <h4>Get Exclusive Offers</h4>
            <p>Sign up and be first to know about what's new.</p>
            <a href="" style={{ color: "skyblue" }}>
              {" "}
              Sign Up
            </a>
          </div>
          <div>
            <img
              src="https://n.nordstrommedia.com/id/33f1ae2c-2ec1-4303-8984-b7bfb5dba920.jpeg?h=188&w=367"
              alt=""
            />
            <h4>Get $5 Off in Our App Now</h4>
            <p>
              And $5 off later in store on purchase of $50 or more. First-time
              download only.
            </p>
            <a href="" style={{ color: "skyblue" }}>
              App Store Google Play
            </a>
          </div>
          <div>
            <img
              src="https://n.nordstrommedia.com/id/e1cf1644-7b25-4a9b-b434-41add33b3af1.jpeg?h=188&w=367"
              alt=""
            />
            <h4>Make Your Wish List</h4>
            <p>
              {" "}
              Create, save and share your lists with the "+ Add to Wish List"
              option.
            </p>
            <a href="" style={{ color: "skyblue" }}>
              {" "}
              Start Adding
            </a>
          </div>
          <div>
            {" "}
            <img
              src="https://n.nordstrommedia.com/id/623fa4cf-360c-4078-86a4-10c6f674f6e8.jpeg?h=188&w=367"
              alt=""
            />
            <h4>The Nordy Club</h4>
            <p>
              Rewards look good on you! Join for free and unlock benefits you'll
              love
            </p>
            <a href="" style={{ color: "skyblue" }}>
              Learn More
            </a>
          </div>
          <div>
            {" "}
            <img
              src="https://n.nordstrommedia.com/id/bbd9bf73-465b-4e89-8d02-61fbfaf6baf6.jpeg?h=188&w=367"
              alt=""
            />
            <h4>Gift Cards & eGift Cards</h4>
            <p> We donate 1% of all Gift Card sales to local nonprofits.</p>
            <a href="" style={{ color: "skyblue" }}>
              Shop Gift Cards
            </a>
          </div>
        </div>
      </div>
    );
  }
  export default Shopyourway;